<template>
    <div style="margin-bottom: 60px">
        <component
            v-model:mainref="mainref"
            v-if="dynamicModal"
            :is="dynamicModal"
            :data="data"
        ></component>
    </div>

    <!-- <Toolbar v-if="data.modalToolbar !== undefined && data.modalToolbar" class="bg-white fixed-bottom">
        <template #start>
            <div v-if="data.footer.leftSide && data.footer.leftSide.buttons">
                <Button v-for="(item, index) in data.footer.leftSide.buttons" :key="index" :label="item.label" :icon="`pi ${item.icon}`" :class="`me-2 ${item.class}`" @click="item.command" />
            </div>
        </template>
        <template #end>
            <div v-if="data.footer.rightSide && data.footer.rightSide.buttons">
                <Button v-for="(item, index) in data.footer.rightSide.buttons" :key="index" :label="item.label" :icon="`pi ${item.icon}`" :class="`me-2 ${item.class}`" @click="item.command" />
            </div>
        </template>
    </Toolbar> -->

    <DAToolbar v-model:mainref="mainref" :data="data" />
</template>


<script>
import { ref, defineAsyncComponent, watchEffect, computed } from "vue";

import DAToolbar from "@/components/toolbar/DAToolbar";

export default {
    name: "DynamicModal",
    props: {
        data: {
            type: Object,
        },
    },
    components: {
        DAToolbar,
    },
    setup(props) {
        const mainref = ref({});
        const showModal = ref(true);
        const dpage = ref(null);

        watchEffect(() => {
            dpage.value = props.data.subpage;
        });

        const dynamicModal = computed(() => {
            if (dpage.value) {
                return defineAsyncComponent({
                    loader: () => import(`@/${dpage.value}`),
                    loadingComponent:
                        '<center><i class="fa fa-sync fa-spin"></i></center>',
                    errorComponent: defineAsyncComponent(() =>
                        import("@/system_modules/NotFound")
                    ),
                    // timeout: 3000,
                    // suspensible: false,
                });
            } else {
                return import("@/system_modules/NotFound");
            }
        });

        return { dynamicModal, showModal, mainref };
    },
};
</script>


<style lang="scss" scoped>
</style>

